import React from 'react';
import { BlueBorderButton, BlueButton } from 'components/Button';
import Modal, { ModalHeader } from 'components/Modal';
import { useSelector } from 'react-redux';

const UserDeleteModal = ({
  name,
  onClose,
  handleDelete,
  userToEdit,
  users
}) => {
  const authenticatedUser = useSelector(state => state.auth.authenticatedUser);
  const usersWithAdminAccess = users.filter(
    user => user.roleName === 'AdminCreateUser' || user.roleName === 'Admin'
  );
  return (
    <Modal>
      {userToEdit.id !== authenticatedUser.id && (
        <ModalHeader paddingBottom="1.3em">
          Are you sure you want to delete {name}?
        </ModalHeader>
      )}
      {userToEdit.id === authenticatedUser.id &&
        usersWithAdminAccess.length > 1 && (
          <ModalHeader paddingBottom="1.3em">
            <p>Are you sure you want to delete your account?</p>
            <p>You will be logged out.</p>
          </ModalHeader>
        )}
      <div>
        <BlueBorderButton margin="0 16px 0 0" onClick={onClose}>
          Cancel
        </BlueBorderButton>
        <BlueButton onClick={handleDelete}>Remove User</BlueButton>
      </div>
    </Modal>
  );
};

export default UserDeleteModal;
